module.exports = __webpack_public_path__ + "static/img/w.174bed1a.png";